/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootshopCreditTransactionHistoryItem } from './LootshopCreditTransactionHistoryItem';
import {
    LootshopCreditTransactionHistoryItemFromJSON,
    LootshopCreditTransactionHistoryItemFromJSONTyped,
    LootshopCreditTransactionHistoryItemToJSON,
    LootshopCreditTransactionHistoryItemToJSONTyped,
} from './LootshopCreditTransactionHistoryItem';

/**
 * 
 * @export
 * @interface LootshopCreditTransactionHistoryResponse
 */
export interface LootshopCreditTransactionHistoryResponse {
    /**
     * 
     * @type {Array<LootshopCreditTransactionHistoryItem>}
     * @memberof LootshopCreditTransactionHistoryResponse
     */
    transactions?: Array<LootshopCreditTransactionHistoryItem>;
    /**
     * Total matching transactions
     * @type {number}
     * @memberof LootshopCreditTransactionHistoryResponse
     */
    total?: number;
    /**
     * Whether more transactions exist beyond this page
     * @type {boolean}
     * @memberof LootshopCreditTransactionHistoryResponse
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the LootshopCreditTransactionHistoryResponse interface.
 */
export function instanceOfLootshopCreditTransactionHistoryResponse(value: object): value is LootshopCreditTransactionHistoryResponse {
    return true;
}

export function LootshopCreditTransactionHistoryResponseFromJSON(json: any): LootshopCreditTransactionHistoryResponse {
    return LootshopCreditTransactionHistoryResponseFromJSONTyped(json, false);
}

export function LootshopCreditTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootshopCreditTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(LootshopCreditTransactionHistoryItemFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function LootshopCreditTransactionHistoryResponseToJSON(json: any): LootshopCreditTransactionHistoryResponse {
    return LootshopCreditTransactionHistoryResponseToJSONTyped(json, false);
}

export function LootshopCreditTransactionHistoryResponseToJSONTyped(value?: LootshopCreditTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(LootshopCreditTransactionHistoryItemToJSON)),
        'total': value['total'],
        'hasMore': value['hasMore'],
    };
}

